import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { categoryApiSlice } from "../../features/category/categoryApiSlice";
import socketSetup from "../../socket-io/socket-io";
import { packageApiSlice } from "../../features/package/packageApiSlice";

export const usePackageSocket = () => {
    const dispatch = useDispatch();

    const invalidatePackage = useCallback(() => {
        dispatch(
            packageApiSlice.util.invalidateTags([
                { type: "Package", id: "LIST" },
            ])
        );
    }, [dispatch]);

    useEffect(() => {
        if (!socketSetup) return;

        socketSetup.on("createPackage", invalidatePackage); 
        socketSetup.on("addPackageItem", invalidatePackage);
        socketSetup.on("updatePackage", invalidatePackage);
        socketSetup.on("updatePackageItem", invalidatePackage);
        // socketSetup.on("deletePackage", invalidatePackage);
        // socketSetup.on("deletePackageItem", invalidatePackage);
        socketSetup.on("activatePackage", invalidatePackage);
        socketSetup.on("inactivatePackage", invalidatePackage);

        return () => {
            socketSetup.off("createPackage", invalidatePackage); 
            socketSetup.off("addPackageItem", invalidatePackage);
            socketSetup.off("updatePackage", invalidatePackage);
            socketSetup.off("updatePackageItem", invalidatePackage);
            // socketSetup.off("deletePackage", invalidatePackage);
            // socketSetup.off("deletePackageItem", invalidatePackage);
            socketSetup.off("activatePackage", invalidatePackage);
            socketSetup.off("inactivatePackage", invalidatePackage);
        };
    }, [invalidatePackage]);
}

// update package
// updatePackageDetails
// updatePackageItems

//   invalidatesTags: (result, error, { productID }) => [
//                 { type: 'Product', id: 'LIST' },
//                 { type: 'Product', id: productID },
//             ],